// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import MaterialBox from "../../../../components/MaterialBox";
import typography from "../../../../assest/theme/base/typography";
import { Box } from "@mui/material";
import logo from '../../../../assest/images/logo.png'

function DashboardFooter({ company }) {
  const { size } = typography;

  return (
    <Box
      sx={{
        display: "flex",
        boxShadow: 4,
        backgroundColor: "#fff",
      }}
    >
      <MaterialBox
        width="100%"
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        justifyContent="flex-end"
        alignItems="flex-end"
        // px={1.5}
      >
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="flex-end"
          flexWrap="wrap"
          color="dark"
          fontSize={size.sm}
          px={1}
        >
          Powered by{" "}
          <a href="" style={{ textDecoration: "none" }}>
            &nbsp;{"KEELIS"}&nbsp;
          </a>{" "}
          <img
            style={{ width: 18, height: 12, marginBottom: 6 }}
            src={logo}
            alt="image not found"
          ></img>
        </MaterialBox>
      </MaterialBox>
    </Box>
  );
}

// Typechecking props for the DashboardFooter
DashboardFooter.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default DashboardFooter;
